/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TopicClientInfoView } from '../../models/topic-client-info-view';

export interface GetAllTopics$Params {
}

export function getAllTopics(http: HttpClient, rootUrl: string, params?: GetAllTopics$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TopicClientInfoView>>> {
  const rb = new RequestBuilder(rootUrl, getAllTopics.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TopicClientInfoView>>;
    })
  );
}

getAllTopics.PATH = '/api/v1/ChangeNotifications/Topics';
